import RequestAbstract from "../abstract";

export default class AccountingGatewayWalletTransfers extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-gateway-wallet-transfers";
    }

}
